<app-header></app-header>
<app-sign-in
  [isLoading]="isLoading"
  (signInData)="onSubmit($event)"
  (googleCredentials)="onSubmitGoogle($event)"
  [whoSignIn]="UserTypeEnum.patient"
></app-sign-in>
